import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appLowercaseInput]'
})
export class LowercaseInputDirective {

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event'])
  c(): void {
    const i = this.el.nativeElement, s = i.selectionStart, t = i.selectionEnd, v = i.value, l = v.toLowerCase();
    v !== l && ((i.value = l), i.setSelectionRange(s, t), i.dispatchEvent(new Event('input', { bubbles: true })));
  }

}
